/**
 * Dagobah-Web-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The CeaInfindProperties model module.
 * @module model/CeaInfindProperties
 * @version 2.8.0
 */
class CeaInfindProperties {
    /**
     * Constructs a new <code>CeaInfindProperties</code>.
     * @alias module:model/CeaInfindProperties
     * @param label {String} 
     * @param uri {String} 
     */
    constructor(label, uri) { 
        
        CeaInfindProperties.initialize(this, label, uri);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, label, uri) { 
        obj['label'] = label;
        obj['uri'] = uri;
    }

    /**
     * Constructs a <code>CeaInfindProperties</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CeaInfindProperties} obj Optional instance to populate.
     * @return {module:model/CeaInfindProperties} The populated <code>CeaInfindProperties</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CeaInfindProperties();

            if (data.hasOwnProperty('label')) {
                obj['label'] = ApiClient.convertToType(data['label'], 'String');
            }
            if (data.hasOwnProperty('uri')) {
                obj['uri'] = ApiClient.convertToType(data['uri'], 'String');
            }
        }
        return obj;
    }


}

/**
 * @member {String} label
 */
CeaInfindProperties.prototype['label'] = undefined;

/**
 * @member {String} uri
 */
CeaInfindProperties.prototype['uri'] = undefined;






export default CeaInfindProperties;

